import { render, staticRenderFns } from "./sider-menu.vue?vue&type=template&id=a2b20532&"
import script from "./sider-menu.ts?vue&type=script&lang=ts&"
export * from "./sider-menu.ts?vue&type=script&lang=ts&"
import style0 from "./sider-menu.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports